import React, { useRef, useEffect, useState } from 'react';
import { components } from 'react-select';
import { SelectorType } from './Selector';
import OverflowTip from '../OverflowTip/OverflowTip';

export const MultiValueComponent = (props: any) => {
  return (
    <components.MultiValue key={props.data.value.toString()} {...props}>
      <span style={{ fontSize: '14px' }}>{props.data.label}</span>
    </components.MultiValue>
  );
};

export const ValueContainerWithOverflowTip = (props: any) => {
  const isMulti = props.selectProps.isMulti;
  const isOverflow = props.selectProps.isOverflow;
  const menuIsOpen = props.selectProps.menuIsOpen;
  const inputValue = props.selectProps.inputValue;
  const selectedValues = props.selectProps.value || [];
  const labels = Array.isArray(selectedValues) ? selectedValues.map((v: SelectorType) => v?.label || '') : [];

  const containerRef = useRef<HTMLDivElement>(null);
  const [overflowLength, setOverflowLength] = useState<number | undefined>(20);

  useEffect(() => {
    if (containerRef.current) {
      const width = containerRef.current?.parentElement?.offsetWidth ?? 0;
      setOverflowLength(Math.ceil((width - (selectedValues.length > 1 ? 120 : 70)) / 9));
    }
  }, [selectedValues, menuIsOpen]);

  // Find the input element among children
  const childrenArray = React.Children.toArray(props.children);
  const inputChild = childrenArray.find(
    (child: any) => child && child.type && (child.type.displayName === 'Input' || child.type.name === 'Input')
  );

  useEffect(() => {
    if (menuIsOpen) {
      containerRef.current?.querySelector('input')?.focus();
    }
  }, [menuIsOpen, selectedValues.length]);

  return (
    <div ref={containerRef} >
      <components.ValueContainer {...props} style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
        {isMulti && isOverflow && Array.isArray(selectedValues) && selectedValues.length > 0 ? (
            menuIsOpen && inputValue ? (
              inputChild
            ) : (
              <>
                <OverflowTip content={labels as any} overflowLength={overflowLength} />
                {inputChild}
              </>
            )
          ) : (
            props.children
          )}
      </components.ValueContainer>
    </div>
  );
}; 